import { render, staticRenderFns } from "./lecturer.vue?vue&type=template&id=8d16082e&scoped=true&"
import script from "./lecturer.vue?vue&type=script&lang=js&"
export * from "./lecturer.vue?vue&type=script&lang=js&"
import style0 from "./lecturer.vue?vue&type=style&index=0&id=8d16082e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d16082e",
  null
  
)

export default component.exports